import { render } from "./ControlliEstrattoBanca.vue?vue&type=template&id=0fabb2e8"
import script from "./ControlliEstrattoBanca.vue?vue&type=script&lang=js"
export * from "./ControlliEstrattoBanca.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__